import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submitButton", "aceitacaoTermos"];

  connect() {
    // console.log("formulario_controller conectado");
    // this.watchAceitacaoTermos();
    // window.Mascaras.start();
  }

  initialize() {
    // console.log("formulario_controller conectado");

    this.campos = JSON.parse(this.data.get("campos"));
    this.camposObrigatorios = JSON.parse(this.data.get("camposObrigatorios"));
    this.deveConcordarComTermos = JSON.parse(
      this.data.get("deveConcordarComTermos")
    );
  }

  // watchAceitacaoTermos() {
  //   var termos_aceitacao_checkbox = $("#inscricao_previa_aceitacao_termos");
  //   if (this.deveConcordarComTermos) {
  //     this.submitButtonTarget.disabled = true;
  //     this.submitButtonTarget.classList.add("disabled");
  //     var submitButtonTarget = this.submitButtonTarget;
  //     termos_aceitacao_checkbox.on("change", function () {
  //       if (termos_aceitacao_checkbox.is(":checked")) {
  //         submitButtonTarget.disabled = false;
  //         submitButtonTarget.classList.remove("disabled");
  //       } else {
  //         submitButtonTarget.disabled = true;
  //         submitButtonTarget.classList.add("disabled");
  //       }
  //     });
  //   }
  // }

  verificarCampos() {
    var email = $("#inscricao_previa_identificador");
    var nome = $("#inscricao_previa_dados_nome");
    var telefone = $("#inscricao_previa_dados_telefone");
    var cpf = $("#inscricao_previa_dados_cpf");
    var sugestao = $("#inscricao_previa_dados_sugestao");
    var checkbox = $("#inscricao_previa_aceitacao_termos");

    if (
      this.campos.includes("nome") &&
      this.camposObrigatorios.includes("nome") &&
      nome.val() == ""
    ) {
      alert("Informe o seu nome");
      nome.trigger("focus");
      return false;
    }

    if (this.deveConcordarComTermos) {
      if (this.campos.includes("cpf")) {
        if (this.camposObrigatorios.includes("cpf") && cpf.val() == "") {
          alert("Informe o seu CPF");
          cpf.trigger("focus");
          return false;
        } else if (
          cpf.val() != "" &&
          !Inputmask.isValid(
            cpf.val(),
            window.Mascaras.maskCpf.userOptions.alias
          )
        ) {
          alert("Informe um CPF válido");
          cpf.trigger("focus");
          return false;
        }
      }
      if (this.campos.includes("telefone")) {
        if (
          this.camposObrigatorios.includes("telefone") &&
          telefone.val() == ""
        ) {
          alert("Informe o seu telefone");
          telefone.trigger("focus");
          return false;
        }

        // else if (telefone.val() != "" && !Inputmask.isValid(telefone.val(), window.Mascaras.maskTelefone.userOptions.alias)) {
        //   alert("Informe um telefone válido");
        //   telefone.trigger("focus");
        //   return false;
        // }
      }
      if (this.campos.includes("email")) {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (this.camposObrigatorios.includes("email") && email.val() == "") {
          alert("Informe o seu email");
          email.trigger("focus");
          return false;
        } else if (email.val() != "" && !regex.test(email.val())) {
          alert("Informe um email válido");
          email.trigger("focus");
          return false;
        }
      }
      if (this.campos.includes("sugestao")) {
        if (
          this.camposObrigatorios.includes("sugestao") &&
          sugestao.val() == ""
        ) {
          alert("Informe a sua sugestão");
          sugestao.trigger("focus");
          return false;
        }
      }
    }

    if (!checkbox.prop("checked")) {
      alert("Você precisa aceitar os termos");
      return false;
    }
  }

  submit() {
    // console.log("formulario_controller submit");

    var form = $("#new_inscricao_previa");

    if (this.verificarCampos() === false) {
      // console.log("formulario_controller submit verificarCampos false");
      return false;
    }

    form.trigger("submit");
    // Rails.fire(form, "submit");
  }
}
